<template>
  <SubmenuMainContainer v-if="useSubmenu" v-model:currentMenu="currentMenu" :menus="menus">
    <template #[SubsectionKey.VarList]>
      <manage-vars-template />
    </template>

    <template #[SubsectionKey.ConnectorList]>
      <ConnectorListTemplate />
    </template>
  </SubmenuMainContainer>

  <MainContainer v-else :with-padding="!route.params.id" :transparent="Boolean(route.params.id)">
    <RouterView :key="route.path" />
  </MainContainer>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useRoute } from "vue-router";

import MainContainer from "@/app/shared/components/organisms/MainContainer.vue";
import SubmenuMainContainer from "@/app/shared/components/organisms/SubmenuMainContainer.vue";
import ManageVarsTemplate from "@/app/manageVars/components/templates/ManageVarsTemplate.vue";
import ConnectorListTemplate from "@/app/ivr/bot/components/templates/ConnectorListTemplate.vue";

enum MenuKey {
  Var = "var",
  Connector = "connector",
}

enum SubsectionKey {
  VarList = "var-list",
  ConnectorList = "connector-list",
}

const route = useRoute();

const useSubmenu = computed(() => route.meta.useSubmenu === true && !route.params.id);

const menus = [
  {
    name: "Gestor de variables",
    key: MenuKey.Var,
    sections: [
      {
        key: SubsectionKey.VarList,
        title: "Listado de variables",
        hideTitle: true,
      },
    ],
  },
  {
    name: "Conectores de API",
    key: MenuKey.Connector,
    sections: [
      {
        key: SubsectionKey.ConnectorList,
        title: "Conectores de API",
      },
    ],
  },
];

const currentMenu = ref<MenuKey>(MenuKey.Var);
</script>
